import { render, staticRenderFns } from "./aiChat.vue?vue&type=template&id=5531c0db&scoped=true&"
import script from "./aiChat.vue?vue&type=script&lang=js&"
export * from "./aiChat.vue?vue&type=script&lang=js&"
import style0 from "./aiChat.vue?vue&type=style&index=0&id=5531c0db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5531c0db",
  null
  
)

export default component.exports